import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _styled from '@emotion/styled-base';
import 'core-js/modules/es6.regexp.search.js';
import { InputGroup, Spinner } from '@blueprintjs/core';
import { Search16, Close16 } from '@carbon/icons-react';
import { Button } from '../button/button.js';
import { Icon } from '../icon/icon.js';
import React__default from 'react';
import { useIntl } from '../../intlContext.js';

var _excluded = ["onClearValue", "isLoading", "hide"];
var TranslationKeys;

(function (TranslationKeys) {
  TranslationKeys["search"] = "varicent-design-system.search-input.search";
})(TranslationKeys || (TranslationKeys = {}));

var defaultTranslation = _defineProperty({}, TranslationKeys.search, function () {
  return "Search";
});

var StyledInputGroup = /*#__PURE__*/_styled(InputGroup, {
  target: "e14kvwma0"
})({
  name: "19petwz",
  styles: "input{padding-right:2rem !important;}"
});

var SearchInput = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var onClearValue = _ref.onClearValue,
      isLoading = _ref.isLoading,
      hide = _ref.hide,
      props = _objectWithoutProperties(_ref, _excluded);

  var intl = useIntl({
    defaultTranslation: defaultTranslation
  });

  if (hide) {
    return /*#__PURE__*/React__default.createElement("input", {
      ref: ref,
      style: {
        display: "none"
      }
    });
  }

  return /*#__PURE__*/React__default.createElement(StyledInputGroup, _extends({
    leftIcon: /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(Search16, null)),
    placeholder: intl.formatMessage({
      id: TranslationKeys.search
    }),
    rightElement: isLoading ? /*#__PURE__*/React__default.createElement(Spinner, {
      size: 16
    }) : props.value === "" || props.value === undefined ? /*#__PURE__*/React__default.createElement(Icon, null, null) // do this so the input doesn't change size
    : /*#__PURE__*/React__default.createElement(Button, {
      icon: Close16,
      onClick: onClearValue,
      "aria-label": intl.formatMessage({
        id: TranslationKeys.search
      }),
      minimal: true
    }),
    inputRef: function inputRef(node) {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    }
  }, props));
});

export { SearchInput };
//# sourceMappingURL=search-input.js.map
